export default __webpack_public_path__ + "static/media/aboutImgMobile.af4735c0.jpg";